import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React, { ReactElement, ReactNode } from 'react';
import { Color } from 'shared/utils/colors';

const baseRootSx = {
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  width: '100%',
  borderRadius: '4px',
  bgcolor: Color.white,
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
  position: 'relative',
  mt: '22px',
  p: 3,
} satisfies SxProps<Theme>;

type BigChartCardProps = {
  noMarginTop?: boolean;
  children?: ReactNode;
  noPadding?: boolean;
};

function BigChartCardComponent({
  children,
  noMarginTop,
  noPadding,
}: BigChartCardProps): ReactElement {
  return (
    <Box
      sx={{
        ...baseRootSx,
        ...(noMarginTop ? { mt: 0 } : {}),
        ...(noPadding ? { p: 0 } : {}),
      }}
    >
      {children}
    </Box>
  );
}

export const BigChartCard = React.memo(BigChartCardComponent);
